module.exports = __webpack_public_path__ + "static/media/gomphocerippus_rufus_002_APA.34a28e17.mp3";